// Tiny shared helpers for the custom Toylivo components. Loaded sitewide via
// header.liquid (before cart/recently-viewed/search scripts that use it) to
// avoid duplicating this logic across independent custom elements.
function toylivoEscapeHtml(value) {
  const div = document.createElement('div');
  div.textContent = value ?? '';
  return div.innerHTML;
}

function toylivoReadStorage(key) {
  try {
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

function toylivoWriteStorage(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // localStorage unavailable (private browsing / quota exceeded) - fail silently
  }
}
